import { Observable } from 'rxjs';

export abstract class AccountsManagementRepository {
    abstract getReceivableSummary(uid: string, cid: string | null, page: number, limit: number, query: string): Observable<any>;
    abstract getPayableSummary(uid: string, cid: string | null, page: number, limit: number, query: string): Observable<any>;
    abstract registerReceivablePayment(uid: string, cid: string | null, accountId: number, data: any): Observable<any>;
    abstract registerPayablePayment(uid: string, cid: string | null, accountId: number, data: any): Observable<any>;
}
